import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import type { Account } from "@repo/app-types/entities/account";
import type { Contact } from "@repo/app-types/entities/contact";
import type { Selector } from "react-redux";
import type { RootState } from "../../app/store.js";

export const accountsAdapter = createEntityAdapter<Account>();

export const selectAccountsDictionary = accountsAdapter.getSelectors(
  (state: RootState) => state.accounts,
).selectEntities;

export const selectAccountForContact = (
  contact: Contact,
): Selector<RootState, Account | null> =>
  createSelector([selectAccountsDictionary], (accounts) => {
    if (!contact.account_id) return null;

    return accounts[contact.account_id] || null;
  });
